(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['../ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.SmartCsV2Sdk) {
      root.SmartCsV2Sdk = {};
    }
    root.SmartCsV2Sdk.ApiDocRecmdContentQueryRequest = factory(root.SmartCsV2Sdk.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';

  /**
   * The ApiDocRecmdContentQueryRequest model module.
   * @module model/ApiDocRecmdContentQueryRequest
   * @version 2.0.624
   */

  /**
   * Constructs a new <code>ApiDocRecmdContentQueryRequest</code>.
   * @alias module:model/ApiDocRecmdContentQueryRequest
   * @class
   * @param queryType
   */
  var exports = function(queryType) {





    this['queryType'] = queryType;



  };

  /**
   * Constructs a <code>ApiDocRecmdContentQueryRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/ApiDocRecmdContentQueryRequest} obj Optional instance to populate.
   * @return {module:model/ApiDocRecmdContentQueryRequest} The populated <code>ApiDocRecmdContentQueryRequest</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) { 
      obj = obj || new exports();

      if (data.hasOwnProperty('category')) {
        obj['category'] = ApiClient.convertToType(data['category'], 'String');
      }
      if (data.hasOwnProperty('limit')) {
        obj['limit'] = ApiClient.convertToType(data['limit'], 'Integer');
      }
      if (data.hasOwnProperty('nextPageToken')) {
        obj['nextPageToken'] = ApiClient.convertToType(data['nextPageToken'], 'String');
      }
      if (data.hasOwnProperty('offset')) {
        obj['offset'] = ApiClient.convertToType(data['offset'], 'Integer');
      }
      if (data.hasOwnProperty('queryType')) {
        obj['queryType'] = ApiClient.convertToType(data['queryType'], 'String');
      }
      if (data.hasOwnProperty('resourceType')) {
        obj['resourceType'] = ApiClient.convertToType(data['resourceType'], 'String');
      }
      if (data.hasOwnProperty('resourceTypes')) {
        obj['resourceTypes'] = ApiClient.convertToType(data['resourceTypes'], ['String']);
      }
      if (data.hasOwnProperty('sortBy')) {
        obj['sortBy'] = ApiClient.convertToType(data['sortBy'], 'String');
      }
    }
    return obj;
  }


  /**
   * @member {module:model/ApiDocRecmdContentQueryRequest.CategoryEnum} category
   */
  exports.prototype['category'] = undefined;

  /**
   * @member {Integer} limit
   */
  exports.prototype['limit'] = undefined;

  /**
   * Token for retrieving next batch of data
   * @member {String} nextPageToken
   */
  exports.prototype['nextPageToken'] = undefined;

  /**
   * <font color=\"FF0000\">[DEPRECATED] Please plan to migrate to use nextPageToken.</font> Number of items to skip.
   * @member {Integer} offset
   */
  exports.prototype['offset'] = undefined;

  /**
   * @member {module:model/ApiDocRecmdContentQueryRequest.QueryTypeEnum} queryType
   */
  exports.prototype['queryType'] = undefined;

  /**
   * <font color=\"FF0000\">[DEPRECATED] Please migrate to use resourceTypes.</font>
   * @member {module:model/ApiDocRecmdContentQueryRequest.ResourceTypeEnum} resourceType
   */
  exports.prototype['resourceType'] = undefined;

  /**
   * @member {Array.<module:model/ApiDocRecmdContentQueryRequest.ResourceTypesEnum>} resourceTypes
   */
  exports.prototype['resourceTypes'] = undefined;

  /**
   * @member {module:model/ApiDocRecmdContentQueryRequest.SortByEnum} sortBy
   */
  exports.prototype['sortBy'] = undefined;


  /**
   * Allowed values for the <code>category</code> property.
   * @enum {String}
   * @readonly
   */
  exports.CategoryEnum = { 
    /**
     * value: MATH
     * @const
     */
    MATH: "MATH",
    
    /**
     * value: ART
     * @const
     */
    ART: "ART",
    
    /**
     * value: SCIENCE
     * @const
     */
    SCIENCE: "SCIENCE"
  };  /**
   * Allowed values for the <code>queryType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.QueryTypeEnum = { 
    /**
     * value: SHARED_BY_ME
     * @const
     */
    SHARED_BY_ME: "SHARED_BY_ME",
    
    /**
     * value: SHARED_WITH_ME
     * @const
     */
    SHARED_WITH_ME: "SHARED_WITH_ME",
    
    /**
     * value: OWNED_BY_ME
     * @const
     */
    OWNED_BY_ME: "OWNED_BY_ME"
  };  /**
   * Allowed values for the <code>resourceType</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ResourceTypeEnum = { 
    /**
     * value: IMAGE
     * @const
     */
    IMAGE: "IMAGE",
    
    /**
     * value: POWERPOINT
     * @const
     */
    POWERPOINT: "POWERPOINT",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: GALLERY
     * @const
     */
    GALLERY: "GALLERY",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS",
    
    /**
     * value: AMP_WORKSPACE
     * @const
     */
    AMP_WORKSPACE: "AMP_WORKSPACE"
  };
  /**
   * Allowed values for the <code>resourceTypes</code> property.
   * @enum {String}
   * @readonly
   */
  exports.ResourceTypesEnum = { 
    /**
     * value: IMAGE
     * @const
     */
    IMAGE: "IMAGE",
    
    /**
     * value: POWERPOINT
     * @const
     */
    POWERPOINT: "POWERPOINT",
    
    /**
     * value: NOTEBOOK
     * @const
     */
    NOTEBOOK: "NOTEBOOK",
    
    /**
     * value: GALLERY
     * @const
     */
    GALLERY: "GALLERY",
    
    /**
     * value: JSON
     * @const
     */
    JSON: "JSON",
    
    /**
     * value: PDF
     * @const
     */
    PDF: "PDF",
    
    /**
     * value: LESSONS
     * @const
     */
    LESSONS: "LESSONS",
    
    /**
     * value: AMP_WORKSPACE
     * @const
     */
    AMP_WORKSPACE: "AMP_WORKSPACE"
  };  /**
   * Allowed values for the <code>sortBy</code> property.
   * @enum {String}
   * @readonly
   */
  exports.SortByEnum = { 
    /**
     * value: fileName
     * @const
     */
    FILENAME: "fileName",
    
    /**
     * value: -fileName
     * @const
     */
    _FILENAME: "-fileName",
    
    /**
     * value: sharedDate
     * @const
     */
    SHAREDDATE: "sharedDate",
    
    /**
     * value: -sharedDate
     * @const
     */
    _SHAREDDATE: "-sharedDate",
    
    /**
     * value: lastAccessed
     * @const
     */
    LASTACCESSED: "lastAccessed",
    
    /**
     * value: -lastAccessed
     * @const
     */
    _LASTACCESSED: "-lastAccessed",
    
    /**
     * value: uploadedDate
     * @const
     */
    UPLOADEDDATE: "uploadedDate",
    
    /**
     * value: -uploadedDate
     * @const
     */
    _UPLOADEDDATE: "-uploadedDate"
  };

  return exports;
}));
